<template>
    <v-container v-resize="onResize">
        <v-layout row wrap align-center v-if="!loading && this.PartyDetails != null">
            <v-flex xs12 md6>
                <v-layout row wrap align-center>
                    <v-flex xs12 md6>
                        <v-btn to="/StatisticalInformation/Parties" color="white" class="v-btn--active">
                            <v-icon dark left>arrow_back</v-icon>Back to Parties
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout row wrap pt-3 pb-4 align-center>
                <h1>{{this.PartyDetails.PrimaryName === "Independent" ? 'Independent Members of Parliament' : this.PartyDetails.PrimaryName }}</h1>
            </v-layout>
                
            </v-flex>
            <v-flex xs12 md6>
                <v-layout row wrap reverse>
                    <v-flex xs6 sm3 v-if="showCurrentChamberSplit && !detailedPartyLoading">
                        <count-up v-if="this.PartyDetails.PrimaryName !== 'Independent'" :endVal="currentHouseMembers" text="Party members in<br />current House of Representatives" />
                        <count-up v-if="this.PartyDetails.PrimaryName === 'Independent'" :endVal="currentHouseMembers" text="Independents in current<br />House of Representatives" />
                    </v-flex>
                    <v-flex xs6 sm3 v-if="showCurrentChamberSplit && !detailedPartyLoading">
                        <count-up v-if="this.PartyDetails.PrimaryName !== 'Independent'" :endVal="currentSenateMembers" text="Party members in<br />current Senate" />
                        <count-up v-if="this.PartyDetails.PrimaryName === 'Independent'" :endVal="currentSenateMembers" text="Independents in<br />current Senate" />
                    </v-flex>
                    <v-flex xs6 sm3>
                        <count-up v-if="this.PartyDetails.PrimaryName !== 'Independent'" :endVal="currentMembers" text="Party members<br />in current Parliament" />
                        <count-up v-if="this.PartyDetails.PrimaryName === 'Independent'" :endVal="currentMembers" text="Independents<br />in current Parliament" />
                    </v-flex>
                    <v-flex xs6 sm3>
                        <count-up v-if="!showOnlyCurrentMembers && this.PartyDetails.PrimaryName !== 'Independent'" :endVal="totalMembers" text="Total party members" />
                        <count-up v-if="!showOnlyCurrentMembers && this.PartyDetails.PrimaryName === 'Independent'" :endVal="totalMembers" text="Total Independents" />
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <br />
        <v-layout row wrap>
            <v-flex xs12 v-if="detailedPartyLoading && !loading">
                <v-card>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div class="loader"></div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
            
            <v-flex xs12 md6>
                <v-layout row wrap>
                    <v-flex sm12 v-if="!detailedPartyLoading  && !loading">
                        <h3>Time in Parliament</h3>
                        <p class="subheading">{{ this.PartyDetails.TimeInParliament }}</p>
                        <h3>Dates represented in Parliament</h3>
                        <chart :chartData="xrange" />
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md6   >
                <div class="ml-4 ml-xs-0" v-if="!detailedPartyLoading && !loading">
                    <h3>{{this.PartyDetails.PrimaryName === "Independent" ? 'Independent Members of Parliament' : 'Party' }} demographics 
                        <span v-if="showOnlyCurrentMembers && this.PartyDetails.PrimaryName !== 'Independent'">(Current members only)</span>
                        <span v-if="showOnlyCurrentMembers && this.PartyDetails.PrimaryName === 'Independent'">(Current only)</span></h3>
                    <chart :chartData="partyChamberDemographics" />
                    <chart :chartData="partyStateDemographics" />
                    <chart :chartData="partyGenderDemographics" />
                </div>
            </v-flex>
        </v-layout>
        <template>
            <v-card v-if="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>

        <v-layout v-if="!loading" row wrap align-center>
            <v-flex v-if="PartyDetails.IsCurrent" xs12 sm2 md2 xl2>
                <v-checkbox v-model="showOnlyCurrentMembers" color="#234fc9" v-on:change="changeCurrentStatus">
                    <template v-slot:label>
                        <span  v-if="PartyDetails.PrimaryName !== 'Independent'" style="color:#000">Current members only</span>
                        <span  v-if="PartyDetails.PrimaryName === 'Independent'" style="color:#000">Current independents only</span>
                    </template>
                </v-checkbox>
            </v-flex>
            <v-flex :class="{'xs12 sm6 md4 xl4' : PartyDetails.IsCurrent, 'xs12 sm6 md4 xl4' : !PartyDetails.IsCurrent }"  >
                <v-card-title class="pb-xs-0 pb-4 mb-0 pl-0">
                    <v-text-field :class="{mobileTextField: isMobile}" v-on:keyup="TRACK_SEARCH" v-model="search" 
                        append-icon="search" :label="getSearchLabel" single-line hide-details>
                    </v-text-field>
                    <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                            <v-subheader>Sort by: </v-subheader>
                            <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-card-title>
            </v-flex>
            <v-flex :class="{'xs12 sm6 md4 xl3' : PartyDetails.IsCurrent, 'xs12 sm6 md4 xl4' : !PartyDetails.IsCurrent }">
                <v-card-title class="pb-0 pt-4 pt-xs-0 mb-0 pl-3 pl-xs-0">
                    <v-autocomplete label="Select a Parliament" v-model="SELECTED_PARLIAMENTS"
                        :items="this.$store.getters.GET_PARLIAMENTS_ORDERED" item-text="Name" item-value="PID"
                        v-on:change="FILTERBY_PARLIAMENT" :filter="FILTER_PARLIAMENT_OPTIONS" auto-select-first
                        multiple small-chips clearable deletable-chips>
                        <template v-slot:selection="{ item, index }">
                            <v-chip @input="deleteParliamentSelectionItem(item.PID)" small close v-if="index == 0">{{item.Name}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{SELECTED_PARLIAMENTS.length - 1}} more</v-chip>
                        </template>
                        <template v-slot:prepend-item v-if="this.$store.getters.GET_PARLIAMENTS.length > 0">
                            <v-list-tile v-on:click="CLICK_CURRENTPARLIAMENT" :value="currentParliamentValue"  ripple>
                                <v-list-tile-action>
                                    <v-icon>{{ currentParliamentIcon }}</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>Current Parliament</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider></v-divider>
                        </template>
                    </v-autocomplete>
                </v-card-title>
            </v-flex>
            <v-flex :class="{'pl-4 pl-xs-0 pt-4 pt-xs-0 xs12 sm6 md4 xl3' : PartyDetails.IsCurrent, 'pl-4 pl-xs-0 pt-4 pt-xs-0 xs12 sm6 md4 xl4' : !PartyDetails.IsCurrent }">
                <v-autocomplete v-if="!detailedPartyLoading" :items="this.$store.getters.GET_STATES"
                    item-text="Name" item-value="Abbrev" :label="stateSelectLabel" v-model="SELECTED_STATES"
                    v-on:change="PERFORM_SEARCH"
                    :filter="FILTER_STATE_OPTIONS" :search-input.sync="stateSearchInput"
                    multiple small-chips deletable-chips>
                    <template v-slot:selection="{ item, index }">
                        <v-chip @input="deleteStateSelectionItem(item.Abbrev)" small close v-if="index == 0">{{item.Name}}</v-chip>
                        <v-chip small v-if="index == 1">+ {{SELECTED_STATES.length - 1}} more</v-chip>
                    </template>
                </v-autocomplete>
            </v-flex>
        </v-layout>
        
        <div v-if="PartyDetails != null && PartyDetails.PartyMembers != null" v-show="!loading">
            <v-data-table :headers="HEADERS" :items="filteredPartyMembers" :rows-per-page-items="ROWS_LISTITEMS" :pagination.sync="PAGINATION" 
                :hide-headers="isMobile"  :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                v-on:update:pagination="UPDATE_PAGINATION"  :custom-sort="customSort">
                <template v-slot:items="props">
                    <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item">
                                    <h3 class="pb-xs-1">{{ props.item.DisplayName }}</h3>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-30">
                                    <div class="flex-item">
                                        <Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait>
                                    </div>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-70">
                                    <div v-if="this.PartyDetails.PrimaryName !== 'Independent'" class="flex-item flex-item-col" data-label="Current party member">
                                        <span style="vertical-align: top; display: inline-block" class="pt-1">{{ props.item.IsCurrent | isBoolean }}</span>
                                        <v-icon small aria-hidden="true" class="mt-1 ml-1" :color="props.item.IsCurrent ? 'green darken-2' : 'red darken-2'">
                                            {{ props.item.IsCurrent ? 'check_circle' : 'cancel' }}
                                        </v-icon> 
                                    </div>
                                    <div v-if="this.PartyDetails.PrimaryName === 'Independent'" class="flex-item flex-item-col" data-label="Current independent">
                                        <span style="vertical-align: top; display: inline-block" class="pt-1">{{ props.item.IsCurrent | isBoolean }}</span>
                                        <v-icon small aria-hidden="true" class="mt-1 ml-1" :color="props.item.IsCurrent ? 'green darken-2' : 'red darken-2'">
                                            {{ props.item.IsCurrent ? 'check_circle' : 'cancel' }}
                                        </v-icon> 
                                    </div>
                                    <div class="flex-item flex-item-col" data-label="Member or Senator">
                                        <v-progress-circular v-if="detailedPartyLoading && props.index == 0" indeterminate size="20" color="#c7c7c7"></v-progress-circular>
                                        <span v-if="!detailedPartyLoading">{{ props.item.CurrentChamber }}</span>
                                    </div>
                                    <div class="flex-item flex-item-col" data-label="Start date">
                                        <p class="mb-0" v-for="record in props.item.PartyRecords" :key="props.item.PHID + '-' + record.StartDateString ">
                                        {{ record.StartDateString }}
                                    </p>
                                    </div>
                                    <div class="flex-item flex-item-col" data-label="End date">
                                        <p class="mb-0" v-for="record in props.item.PartyRecords" :key="props.item.PHID + '-' + record.EndDateString">
                                            <span v-if="record.EndDateString != ''">{{ record.EndDateString }}</span>
                                            <span v-else>N/A</span>
                                        </p>
                                    </div>
                                    <div class="flex-item flex-item-col" v-if="this.PartyDetails.PrimaryName === 'Independent'" data-label="Time as Independent">
                                        {{ props.item.TimeInParty }}
                                    </div>
                                    <div class="flex-item flex-item-col" v-if="this.PartyDetails.PrimaryName !== 'Independent'" data-label="Time in party">
                                        {{ props.item.TimeInParty }}
                                    </div>
                                    <div class="flex-item flex-item-col" data-label="States">
                                        <v-progress-circular v-if="detailedPartyLoading && props.index == 0" indeterminate size="20" color="#c7c7c7"></v-progress-circular>
                                        <span v-if="!detailedPartyLoading">{{ props.item.States != null ? props.item.States.join(', ') : '' }}</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </router-link>
                    <router-link v-else class="tr" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}">
                        <td class="text-xs-left"><Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait></td>
                        <td class="text-xs-left">{{ props.item.DisplayName }}</td>
                        <td class="text-xs-left">
                            <span style="vertical-align: top; display: inline-block" class="pt-1">{{ props.item.IsCurrent | isBoolean }}</span>
                            <v-icon small aria-hidden="true" class="mt-1 ml-1" :color="props.item.IsCurrent ? 'green darken-2' : 'red darken-2'">
                                {{ props.item.IsCurrent ? 'check_circle' : 'cancel' }}
                            </v-icon> 
                        </td>
                        <td class="text-xs-left">{{ props.item.CurrentChamber }}</td>
                        <td class="text-xs-left">
                            <p class="mb-0" v-for="record in props.item.PartyRecords" :key="props.item.PHID + '-' + record.StartDateString">
                                {{ record.StartDateString }}
                            </p>
                        </td>
                        <td class="text-xs-left">
                            <p class="mb-0" v-for="record in props.item.PartyRecords" :key="props.item.PHID + '-' + record.StartDateString">
                                <span v-if="record.EndDateString != ''">{{ record.EndDateString }}</span>
                                <span v-else>N/A</span>
                            </p>
                        </td>
                        <td class="text-xs-left">{{ props.item.TimeInParty }}</td>
                        <td class="text-xs-left">
                            <v-progress-circular v-if="detailedPartyLoading && props.index == 0" indeterminate size="20" color="#c7c7c7"></v-progress-circular>
                            <span v-if="!detailedPartyLoading">{{ props.item.States != null ? props.item.States.join(', ') : '' }}</span>
                        </td>
                    </router-link>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>

            <v-layout row wrap>
                <v-flex xs12>
                    <div style="float:right">
                        <v-btn v-on:click="EXPORT_PARTY_PDF" v-on:keyup.enter="EXPORT_PARTY_PDF" color="primary">
                            <v-icon aria-hidden="true" :class="pdfDownloadClass">{{pdfDownloadIcon}}</v-icon>
                            <span >&nbsp;Download as PDF</span>
                        </v-btn>
                        <v-btn v-on:click="EXPORT_PARTY_CSV" v-on:keyup.enter="EXPORT_PARTY_CSV" color="primary">
                            <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                            <span >&nbsp;Download as CSV</span>
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </div>

    </v-container>
</template>


<script>
    window.scrollTo(0, 0);
    import StatisticalHeader from './StatisticalHeader.vue';
    import Portrait from '@/components/Portrait.vue'
    import CountUp from './CountUp.vue'
    import Chart from './Chart.vue'
    import axios from 'axios'

    export default {
        components: {
            Portrait,
            Chart,
            CountUp,
            StatisticalHeader
        },
        props: {
            Party: {
                type: String,
                required: true
            },
            CurrentOnly: {
                required: false,
                value: false
            }
        },
        data() {
            return {
                loading: true,
                detailedPartyLoading: true,
                initialLoad: true,
                isMobile: false,
                showOnlyCurrentMembers: false,
                search: '',
     
                filteredPartyMembers: [],
                totalMembers: 0,
                currentMembers: 0,
                currentHouseMembers: 0,
                currentSenateMembers: 0,
                showCurrentChamberSplit: false,
                parliamentarians: [],
                pdfDownloading: false,
                csvDownloading: false,
                PARLIAMENTS: this.$store.getters.GET_PARLIAMENTS,
                SELECTED_PARLIAMENTS: [],
                stateSearchInput: '',
                SELECTED_STATES: [],
                PartyDetails: null,
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],
                PAGINATION: {
                    page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE
                },
                HEADERS: [
                    {
                        text: 'Image',
                        value: 'DisplayName',
                        align: 'left',
                        sortable: false,
                        width: "60px",
                    },
                    {
                        text: 'Name',
                        value: 'DisplayName',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'Current party member',
                        value: 'IsCurrent',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'Member or Senator',
                        value: 'CurrentChamber',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'Start Date',
                        value: 'StartDate',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'End Date',
                        value: 'EndDate',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'Time in party',
                        value: 'DaysInParty',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'States represented',
                        value: 'States',
                        align: 'left',
                        sortable: true
                    },  
                ],
            }
        },
        mounted(){
            this.onResize();
            if (this.$route.query.current != null && this.$route.query.current.toLowerCase() == 'true') {
                this.showOnlyCurrentMembers = true;
            }

            if (this.$route.query.s) {
                this.search = this.$route.query.s;
            }

            if (this.$route.query.parliaments) {
                this.SELECTED_PARLIAMENTS = this.$route.query.parliaments
                    .split(",")
                    .map((p) => parseInt(p));
            }

            if (this.$route.query.states) {
                this.SELECTED_STATES = this.$route.query.states
                    .split(",")
                    .map((p) => p.replace("%20", ""));
            } else {
                this.SELECTED_STATES = [];
            }

            if (this.$route.query.page) {
                this.PAGINATION.page = parseInt(this.$route.query.page);
            }

            if (this.$route.query.pageSize) {
                this.PAGINATION.rowsPerPage = parseInt(this.$route.query.pageSize);
            }

            this.loadParty();
        },
        watch: {
            'PAGINATION.page': function (newPage, oldPage) {
                if (typeof oldPage !== 'undefined' && newPage !== oldPage && !(this.initialLoad && newPage === 1)) {
                    this.PERFORM_SEARCH();
                }
            },
        },
        methods: {
            onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                }
                else{
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            changeCurrentStatus() {
                let query = this.$router.query || {};

                if (this.showOnlyCurrentMembers) {
                    query.current = 'true';
                }

                if (Object.keys(query).length > 0) {
                    history.replaceState(
                    {},
                    null,
                    this.$route.path +
                        "?" +
                        Object.keys(query)
                        .map((key) => {
                            return key + "=" + query[key];
                        })
                        .join("&")
                    );
                } else {
                    history.replaceState({}, null, this.$route.path);
                }

                this.loadParty();
            },
            loadParty() {
                this.loading = true;
                if (this.showOnlyCurrentMembers){

                    const url = `partiesdata/partycurrentmembers?partyID=${this.Party}`;
                    axios.get(`api/${url}`).then((response) => {
                        this.PartyDetails = response.data;
                        this.filteredPartyMembers = response.data.PartyMembers;
                        this.totalMembers = this.PartyDetails.PartyMembers.length;
                        this.currentMembers = this.PartyDetails.PartyMembers.filter(p => p.IsCurrent).length;
                        this.showCurrentChamberSplit = this.currentMembers > 0;
                        if (this.PartyDetails != null){
                            window.document.title = this.PartyDetails.PrimaryName;   
                        }
                        
                        if (this.PartyDetails.PrimaryName == "Independent"){
                            this.HEADERS = [
                            {
                                text: 'Image',
                                value: 'DisplayName',
                                align: 'left',
                                sortable: false,
                                width: "60px",
                            },
                            {
                                text: 'Name',
                                value: 'DisplayName',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'Current independent',
                                value: 'IsCurrent',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'Member or Senator',
                                value: 'CurrentChamber',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'Start Date',
                                value: 'StartDate',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'End Date',
                                value: 'EndDate',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'Time as independent',
                                value: 'DaysInParty',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'States represented',
                                value: 'States',
                                align: 'left',
                                sortable: true
                            },  
                        ];
                        }

                        this.loading = false;

                        if (!this.loading && !this.detailedPartyLoading){
                            // on initial load, have to reset the page number to what it was before
                            if (this.initialLoad && this.$route.query.page) {
                                this.$nextTick().then(() => {
                                    this.$set(this.PAGINATION, 'page', parseInt(this.$route.query.page));
                                    this.initialLoad = false;
                                });
                            }
                        }

                        const detailedUrl = `partiesdata/partycurrentmembersdetailed?partyID=${this.Party}`;
                            axios.get(`api/${detailedUrl}`).then((response) => {
                            this.PartyDetails = response.data;
                            
                            for (var index = 0; index < this.PartyDetails.PartyMembers.length; ++index) {
                                if (this.PartyDetails.PartyMembers[index].Demographics != null){
                                    var states = this.PartyDetails.PartyMembers[index].Demographics.map(value => value.States).flat().map(value => value.State).flat();
                                    let uniqueStates = [...new Set(states)];
                                    this.PartyDetails.PartyMembers[index].States = uniqueStates;
                                    var parliaments = this.PartyDetails.PartyMembers[index].Demographics.flat().map(value => value.Parliament).flat();
                                    let uniqueParliaments = [...new Set(parliaments)];
                                    this.PartyDetails.PartyMembers[index].Parliaments = uniqueParliaments;
                                    var house = this.PartyDetails.PartyMembers[index].Demographics.map(value => value.States).flat().map(value => value.MemberCount).flat();
                                    var senate = this.PartyDetails.PartyMembers[index].Demographics.map(value => value.States).flat().map(value => value.SenatorCount).flat();
                                    this.PartyDetails.PartyMembers[index].Member = house.filter(h => h == 1).length > 0;
                                    this.PartyDetails.PartyMembers[index].Senator = senate.filter(h => h == 1).length > 0;
                                }
                            }

                            this.filteredPartyMembers = response.data.PartyMembers;
                            this.currentMembers = this.PartyDetails.PartyMembers.filter(p => p.IsCurrent).length;
                            this.showCurrentChamberSplit = this.currentMembers > 0;

                            if (this.showCurrentChamberSplit){
                                this.currentHouseMembers = this.PartyDetails.PartyMembers.filter(p => p.IsCurrent && p.CurrentChamber == "Member").length;
                                this.currentSenateMembers = this.PartyDetails.PartyMembers.filter(p => p.IsCurrent && p.CurrentChamber == "Senator").length;
                            }
                            this.detailedPartyLoading = false;

                            if (!this.loading && !this.detailedPartyLoading){
                                // on initial load, have to reset the page number to what it was before
                                if (this.initialLoad && this.$route.query.page) {
                                    this.$nextTick().then(() => {
                                        this.$set(this.PAGINATION, 'page', parseInt(this.$route.query.page));
                                        this.initialLoad = false;
                                    });
                                }
                            }
                            this.PERFORM_SEARCH();
                        });
                    });

                    
                    
                }
                else {
                    const url = `partiesdata/party?partyID=${this.Party}`;
                    axios.get(`api/${url}`).then((response) => {
                        this.PartyDetails = response.data;
                        this.filteredPartyMembers = response.data.PartyMembers;
                        this.totalMembers = this.PartyDetails.PartyMembers.length;
                        this.currentMembers = this.PartyDetails.PartyMembers.filter(p => p.IsCurrent).length;
                        this.showCurrentChamberSplit = this.currentMembers > 0;

                        if (this.PartyDetails != null){
                            window.document.title = this.PartyDetails.PrimaryName;   
                        }
                        
                        if (this.PartyDetails.PrimaryName == "Independent"){
                            this.HEADERS = [
                            {
                                text: 'Image',
                                value: 'DisplayName',
                                align: 'left',
                                sortable: false,
                                width: "60px",
                            },
                            {
                                text: 'Name',
                                value: 'DisplayName',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'Current independent',
                                value: 'IsCurrent',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'Member or Senator',
                                value: 'CurrentChamber',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'Start Date',
                                value: 'StartDate',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'End Date',
                                value: 'EndDate',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'Time as independent',
                                value: 'DaysInParty',
                                align: 'left',
                                sortable: true,
                            },
                            {
                                text: 'States represented',
                                value: 'States',
                                align: 'left',
                                sortable: true
                            },  
                        ];
                        }

                        this.loading = false;

                        if (!this.loading && !this.detailedPartyLoading){
                            // on initial load, have to reset the page number to what it was before
                            if (this.initialLoad && this.$route.query.page) {
                                this.$nextTick().then(() => {
                                    this.$set(this.PAGINATION, 'page', parseInt(this.$route.query.page));
                                    this.initialLoad = false;
                                });
                            }
                            this.PERFORM_SEARCH();
                        }

                        const detailedUrl = `partiesdata/partydetailed?partyID=${this.Party}`;
                            axios.get(`api/${detailedUrl}`).then((response) => {
                            this.PartyDetails = response.data;

                            for (var index = 0; index < this.PartyDetails.PartyMembers.length; ++index) {
                                if (this.PartyDetails.PartyMembers[index].Demographics != null){
                                    var states = this.PartyDetails.PartyMembers[index].Demographics.map(value => value.States).flat().map(value => value.State).flat();
                                    let uniqueStates = [...new Set(states)];
                                    this.PartyDetails.PartyMembers[index].States = uniqueStates;
                                    var parliaments = this.PartyDetails.PartyMembers[index].Demographics.flat().map(value => value.Parliament).flat();
                                    let uniqueParliaments = [...new Set(parliaments)];
                                    this.PartyDetails.PartyMembers[index].Parliaments = uniqueParliaments;
                                    var house = this.PartyDetails.PartyMembers[index].Demographics.map(value => value.States).flat().map(value => value.MemberCount).flat();
                                    var senate = this.PartyDetails.PartyMembers[index].Demographics.map(value => value.States).flat().map(value => value.SenatorCount).flat();
                                    this.PartyDetails.PartyMembers[index].Member = house.filter(h => h == 1).length > 0;
                                    this.PartyDetails.PartyMembers[index].Senator = senate.filter(h => h == 1).length > 0;
                                }
                            }

                            this.filteredPartyMembers = response.data.PartyMembers;

                            this.currentMembers = this.PartyDetails.PartyMembers.filter(p => p.IsCurrent).length;
                            this.showCurrentChamberSplit = this.currentMembers > 0;

                            if (this.showCurrentChamberSplit){
                                this.currentHouseMembers = this.PartyDetails.PartyMembers.filter(p => p.IsCurrent && p.CurrentChamber == "Member").length;
                                this.currentSenateMembers = this.PartyDetails.PartyMembers.filter(p => p.IsCurrent && p.CurrentChamber == "Senator").length;
                            }

                            this.detailedPartyLoading = false;

                            if (!this.loading && !this.detailedPartyLoading){
                                // on initial load, have to reset the page number to what it was before
                                if (this.initialLoad && this.$route.query.page) {
                                    this.$nextTick().then(() => {
                                        this.$set(this.PAGINATION, 'page', parseInt(this.$route.query.page));
                                        this.initialLoad = false;
                                    });
                                }
                                this.PERFORM_SEARCH();
                            }
                        });
                    });
                }

                
            },
            EXPORT_PARTY_CSV() {
                this.$gtag.event(`party ${this.PartyDetails.PrimaryName} download csv`, {
                    'event_category': 'downloads',
                    'event_label': `party ${this.PartyDetails.PrimaryName} csv download`,
                    'value': 1
                });

                this.csvDownloading = true;

                let OBJ_records = [];
                let headers = ['Name', 'PHID', (this.PartyDetails.PrimaryName == "Independent" ? 'Current independent' :'Current party member'), 'Start Date', 'End Date', 
                (this.PartyDetails.PrimaryName == "Independent" ? 'Days as independent' :'Days in party'),
                 (this.PartyDetails.PrimaryName == "Independent" ? 'Time as independent' :'Time in party'), 'States'];
                let filename = `${this.PartyDetails.PrimaryName}`
                let index = 0;
                let inner = 0;

                //  then we progressively build up the  exportOBJ
                for (index = 0; index < this.PartyDetails.PartyMembers.length; ++index) {
                    for (inner = 0; inner < this.PartyDetails.PartyMembers[index].PartyRecords.length; ++inner) {
                        if (this.PartyDetails.PrimaryName == "Independent"){
                            OBJ_records.push({
                            'Name': this.PartyDetails.PartyMembers[index].DisplayName,
                            'PHID': this.PartyDetails.PartyMembers[index].PHID,
                            'Current independent': this.PartyDetails.PartyMembers[index].IsCurrent,
                            'Member or Senator': this.PartyDetails.PartyMembers[index].CurrentChamber,
                            'Start Date': this.PartyDetails.PartyMembers[index].PartyRecords[inner].CorrectedStartDateString,
                            'End Date': this.PartyDetails.PartyMembers[index].PartyRecords[inner].CorrectedEndDateString,
                            'Days as independent': this.PartyDetails.PartyMembers[index].DaysInParty,
                            'Time as independent': this.PartyDetails.PartyMembers[index].TimeInParty,
                            'States': this.PartyDetails.PartyMembers[index].States != null ? this.PartyDetails.PartyMembers[index].States.join(', ') : '',
                        });
                        }
                        else {
                            OBJ_records.push({
                            'Name': this.PartyDetails.PartyMembers[index].DisplayName,
                            'PHID': this.PartyDetails.PartyMembers[index].PHID,
                            'Current party member': this.PartyDetails.PartyMembers[index].IsCurrent,
                            'Member or Senator': this.PartyDetails.PartyMembers[index].CurrentChamber,
                            'Start Date': this.PartyDetails.PartyMembers[index].PartyRecords[inner].CorrectedStartDateString,
                            'End Date': this.PartyDetails.PartyMembers[index].PartyRecords[inner].CorrectedEndDateString,
                            'Days in party': this.PartyDetails.PartyMembers[index].DaysInParty,
                            'Time in party': this.PartyDetails.PartyMembers[index].TimeInParty,
                            'States': this.PartyDetails.PartyMembers[index].States != null ? this.PartyDetails.PartyMembers[index].States.join(', ') : '',
                        });
                        }
                        
                    }
                }
                this.$store.dispatch('GETCSV', { DATA: OBJ_records, HEADERS: headers, FILENAME: filename })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
                OBJ_records = null;
                index = null;
            },

            EXPORT_PARTY_PDF: function () {
                this.$gtag.event(`party ${this.PartyDetails.PrimaryName} download pdf`, {
                    'event_category': 'downloads',
                    'event_label': `party ${this.PartyDetails.PrimaryName} pdf download`,
                    'value': 1
                });

                this.pdfDownloading = true;

                let url = `${this.$store.state.URL_API}/document/party`;

                let partyModel = { Party: this.PartyDetails.PrimaryName, Members: [] }

                for (let i = 0; i < this.PartyDetails.length; i++) {
                    partyModel.Members.push({
                        DisplayName: this.PARTY[i].DisplayName
                        , PHID: this.PARTY[i].PHID
                        , MpOrSenator: this.PARTY[i].MPorSenator.join('\n')
                        , Party: this.Party
                        , StartDate: this.PARTY[i].PartyService_Start
                        , EndDate: this.PARTY[i].PartyService_End
                    });
                }

                let index = 0;
                let inner = 0;

                //  then we progressively build up the  exportOBJ
                 for (index = 0; index < this.PartyDetails.PartyMembers.length; ++index) {
                    for (inner = 0; inner < this.PartyDetails.PartyMembers[index].PartyRecords.length; ++inner) {
                        partyModel.Members.push({
                            DisplayName: this.PartyDetails.PartyMembers[index].DisplayName,
                            PHID: this.PartyDetails.PartyMembers[index].PHID,
                            MpOrSenator:  this.PartyDetails.PartyMembers[index].CurrentChamber,
                            Party: this.PartyDetails.PrimaryName,
                            StartDate: this.PartyDetails.PartyMembers[index].PartyRecords[inner].CorrectedStartDateString,
                            EndDate: this.PartyDetails.PartyMembers[index].PartyRecords[inner].CorrectedEndDateString,
                        });
                    }
                }

                axios.post(url, partyModel, { responseType: 'arraybuffer' })
                    .then((response) => {
                        let blob = new Blob([response.data], { type: 'application/pdf' }),
                            downloadUrl = window.URL.createObjectURL(blob),
                            filename = `${this.PartyDetails.PrimaryName}.pdf`

                        let a = document.createElement("a");
                        if (typeof a.download === "undefined") {
                            window.location.href = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                        a.remove();
                    }).catch(this.showError)
                    .finally(() => this.pdfDownloading = false);
            },

            UPDATE_PAGINATION: function (options) {
                this.$gtag.event(`party ${this.Party} pagination items per page`, {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event(`party ${this.Party} pagination page`, {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
            },

            TRACK_SEARCH: function () {
                if (this.search.length >= 3) {
                    this.$gtag.event(`party ${this.Party} - search`, {
                        'event_category': 'filters',
                        'event_label': this.search,
                        'value': 1
                    });
                }
                return this.PERFORM_SEARCH()
            },
            customSort(items, index, isDesc) {
                items.sort((a, b) => {
                    if (index === 'StartDate') {
                        if (!isDesc) {
                            a.PartyRecords = a.PartyRecords.sort((c, d) => (c.StartDate > d.StartDate) ? 1 : -1)
                            b.PartyRecords = b.PartyRecords.sort((c, d) => (c.StartDate > d.StartDate) ? 1 : -1)
                            const aService = a.PartyRecords[0].StartDate;
                            const bService = b.PartyRecords[0].StartDate;
                            return aService < bService ? -1 : 1;
                        } else {
                            a.PartyRecords = a.PartyRecords.sort((c, d) => (c.StartDate < d.StartDate) ? 1 : -1)
                            b.PartyRecords = b.PartyRecords.sort((c, d) => (c.StartDate < d.StartDate) ? 1 : -1)
                            const aService = a.PartyRecords[0].StartDate;
                            const bService = b.PartyRecords[0].StartDate;
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'EndDate') {
                        if (!isDesc) {
                            a.PartyRecords = a.PartyRecords.sort((c, d) => (c.EndDate > d.EndDate) ? 1 : -1)
                            b.PartyRecords = b.PartyRecords.sort((c, d) => (c.EndDate > d.EndDate) ? 1 : -1)
                            const aService = a.PartyRecords[0].EndDate;
                            const bService = b.PartyRecords[0].EndDate;
                            if (aService == null || aService == '0001-01-01T00:00:00') {
                                return 1;
                            }
                            else if (bService == null || bService == '0001-01-01T00:00:00') {
                                return -1;
                            }
                            return aService < bService ? -1 : 1;
                        } else {
                            a.PartyRecords = a.PartyRecords.sort((c, d) => (c.EndDate < d.EndDate) ? 1 : -1)
                            b.PartyRecords = b.PartyRecords.sort((c, d) => (c.EndDate < d.EndDate) ? 1 : -1)
                            const aService = a.PartyRecords[0].EndDate;
                            const bService = b.PartyRecords[0].EndDate;
                            if (aService == null || aService == '0001-01-01T00:00:00') {
                                return -1;
                            }
                            else if (bService == null || bService == '0001-01-01T00:00:00') {
                                return 1;
                            }
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'States') {
                        if (!isDesc) {
                            a.States = a.States.sort((c, d) => (c > d) ? 1 : -1)
                            b.States = b.States.sort((c, d) => (c > d) ? 1 : -1)
                            const aService = a.States[0];
                            const bService = b.States[0];
                            return aService < bService ? -1 : 1;
                        } else {
                            a.States = a.States.sort((c, d) => (c < d) ? 1 : -1)
                            b.States = b.States.sort((c, d) => (c < d) ? 1 : -1)
                            const aService = a.States[0]
                            const bService = b.States[0];
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else {
                        if (!isDesc) {
                            return a[index] < b[index] ? -1 : 1;
                        } else {
                            return b[index] < a[index] ? -1 : 1;
                        }
                    }
                });
                return items;
            }, 
            FILTER_STATE_OPTIONS: function (item, queryText) {
                const abbrev = item.Abbrev.toLowerCase();
                const name = item.Name.toLowerCase();
                const searchText = queryText.toLowerCase()
                return name.indexOf(searchText) > -1 || abbrev.indexOf(searchText) > -1;
            },
            deleteStateSelectionItem(item) {
                this.SELECTED_STATES = this.SELECTED_STATES.filter(find => find !== item);
                this.PERFORM_SEARCH();
            },
            deleteParliamentSelectionItem(item) {
                this.SELECTED_PARLIAMENTS = this.SELECTED_PARLIAMENTS.filter(find => find !== item);
                this.PERFORM_SEARCH();
            },  
            FILTERBY_PARLIAMENT: function (parliaments) {
                this.$gtag.event("parties parliament filter", {
                    event_category: "filters",
                    event_label: `parliaments selected: ${
                    parliaments.length > 0 ? parliaments.join(",") : "none"
                    }`,
                    value: 1,
                });
                return this.PERFORM_SEARCH();
            },
            FILTER_PARLIAMENT_OPTIONS: function (item, queryText) {
                const pId = item.PID;
                const name = item.Name.toLowerCase();
                const searchText = queryText.toLowerCase();
                return (
                    name.indexOf(searchText) > -1 || pId.toString().indexOf(searchText) > -1
                );
            },
            CLICK_CURRENTPARLIAMENT: function () {
                this.$nextTick(() => {
                    let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                    let currentParliament = parliaments[0].PID;
                    if (this.SELECTED_PARLIAMENTS.includes(currentParliament)) {
                        let index = this.SELECTED_PARLIAMENTS.indexOf(currentParliament);
                        if (index > -1) {
                            this.SELECTED_PARLIAMENTS.splice(index, 1);
                        }
                    } else {
                        this.SELECTED_PARLIAMENTS.push(currentParliament);
                    }
                    this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
                });
            }, 
            PERFORM_SEARCH: function () {
                let query = this.$router.query || {};

                if (this.search) {
                    query.s = this.search;
                }
                
                this.filteredPartyMembers = this.PartyDetails.PartyMembers.slice()
                    .filter(i => (i.DisplayName.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                        || (i.States.filter(e => e.toLowerCase().indexOf(this.search.toLowerCase()) > -1).length > 0)
                        || (i.PHID.toLowerCase().trim() == this.search.toLowerCase().trim()));

                if (this.SELECTED_STATES.length > 0) {
                    if (this.filteredPartyMembers.length === 0) {
                        this.filteredPartyMembers = this.PartyDetails.PartyMembers.slice();
                    }

                    this.filteredPartyMembers = this.filteredPartyMembers.filter(i => i.States.filter(e => 
                        this.SELECTED_STATES.find(s => s.toLowerCase() == e.toLowerCase()) !== undefined).length > 0);
                }

                if (this.SELECTED_PARLIAMENTS.length > 0) {
                    if (this.filteredPartyMembers.length === 0) {
                        this.filteredPartyMembers = this.PartyDetails.PartyMembers.slice();
                    }

                    this.filteredPartyMembers = this.filteredPartyMembers.filter(i => i.Demographics != null
                         && i.Demographics.filter(p => this.SELECTED_PARLIAMENTS.find(sp => sp == p.Parliament) !== undefined).length > 0);

                        for (var index = 0; index <  this.filteredPartyMembers.length; ++index) {
                            if ( this.filteredPartyMembers[index].Demographics != null){
                                var states =  this.filteredPartyMembers[index].Demographics
                                    .filter(d => this.SELECTED_PARLIAMENTS.find(sp => sp == d.Parliament) !== undefined).map(value => value.States)
                                    .flat().map(value => value.State).flat();
                                let uniqueStates = [...new Set(states)];
                                this.filteredPartyMembers[index].States = uniqueStates;
                                
                            }
                        }
                }

                if (!this.search  && this.SELECTED_STATES.length == 0 && this.SELECTED_PARLIAMENTS.length == 0) {
                    this.filteredPartyMembers = this.PartyDetails.PartyMembers.slice();
                }

                if (this.SELECTED_PARLIAMENTS.length > 0) {
                    query.parliaments = this.SELECTED_PARLIAMENTS.join(",");
                }

                if (this.SELECTED_STATES.length > 0) {
                    query.states = this.SELECTED_STATES.join(",");
                }

                if (this.showOnlyCurrentMembers) {
                    query.current = 'true';
                }

                if (this.PAGINATION.page && !(this.initialLoad && this.PAGINATION.page === 1)) {
                    query.page = this.PAGINATION.page;
                }

                if (this.PAGINATION.rowsPerPage != 50) {
                    query.pageSize = this.PAGINATION.rowsPerPage;
                }

                if (Object.keys(query).length > 0) {
                    history.replaceState(
                    {},
                    null,
                    this.$route.path +
                        "?" +
                        Object.keys(query)
                        .map((key) => {
                            return key + "=" + query[key];
                        })
                        .join("&")
                    );
                } else {
                    history.replaceState({}, null, this.$route.path);
                }
            },
        },

        computed: {
            currentParliamentIcon: function () {
                let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                let currentParliament = parlArray[0].PID;
                if (this.SELECTED_PARLIAMENTS.indexOf(currentParliament) > -1) {
                    return '$vuetify.icons.checkboxOn';
                } else {
                    return '$vuetify.icons.checkboxOff';
                }
            },
            currentParliamentValue: function () {
                let parlArray = this.$store.getters.GET_PARLIAMENTS;
                if (
                    this.SELECTED_PARLIAMENTS.includes(parlArray[parlArray.length - 1].PID)
                ) {
                    return parlArray[parlArray.length - 1].PID;
                } else {
                    return false;
                }
            },
            stateSelectLabel: function () {
                var label = 'Select a State';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'State';
                }
                return label;
            },
            getSearchLabel: function() {
                return this.PartyDetails.PrimaryName === "Independent" ? "Search independents" : "Search party members";
            },
            pdfDownloadIcon(){
                return this.pdfDownloading ? 'cached' : 'picture_as_pdf';
            },
            pdfDownloadClass(){
                let pdfClass = 'mr-1';
                if (this.pdfDownloading){
                    pdfClass = pdfClass + ' loading'
                }
                return pdfClass;
            },
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            partyStateDemographics() {
                const stateCounts = {};

                for (const item of this.filteredPartyMembers.map(value => value.States).flat()) {
                    stateCounts[item] = stateCounts[item] ? stateCounts[item] + 1 : 1;
                }
                const series = Object.entries(stateCounts).map(([o, v]) => ({
                    name: o.toUpperCase(),
                    data: [v],
                    pointWidth: 50,
                    visible: true,
                    showInLegend: false,
                    groupPadding: 0
                }));

                const categories = ['State'];

                return {
                    chart: {
                        type: 'bar',
                        height:40,
                        marginLeft: 70,
                        backgroundColor: 'rgba(0,0,0,0)'
                    },
                    exporting: {
                        enabled: false,
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        categories: categories,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    yAxis:{
                        visible: false,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    tooltip: {
                        pointFormat: '<span>{series.name}</span>: <b>{point.y} party members</b> ({point.percentage:.0f}%)<br/>',
                        outside:true
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'percent'
                        }
                    },
                    legend: {
                        visible: false
                    },
                    series: series
                };
            },
            partyChamberDemographics() {
                const chamberCounts = {};

                for (const item of this.filteredPartyMembers.map(value => value.CurrentChamber).flat()) {
                    chamberCounts[item] = chamberCounts[item] ? chamberCounts[item] + 1 : 1;
                }

                const series = [ {
                    name: "Senators",
                    data: [this.filteredPartyMembers.filter(m => m.Senator).length],
                    pointWidth:50,
                    visible: true,
                    color: this.$store.state.COLOUR_SENATE,
                    showInLegend: false
                }, {
                    name: "Members",
                    data: [this.filteredPartyMembers.filter(m => m.Member).length],
                    pointWidth:50,
                    visible: true,
                    color: this.$store.state.COLOUR_REPRESENTATIVES,
                    showInLegend: false
                }];
                
                const categories = ['Chamber'];

                return {
                    chart: {
                        type: 'bar',
                        height:40,
                           marginLeft: 70,
                        backgroundColor: 'rgba(0,0,0,0)'
                    },
                    exporting: {
                        enabled: false,
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        categories: categories,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    yAxis:{
                        visible: false,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    tooltip: {
                        pointFormat: '<span>{series.name}</span>: <b>{point.y} party members</b> ({point.percentage:.0f}%)<br/>',
                        outside:true
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'percent'
                        }
                    },
                    legend: {
                        visible: false
                    },
                    series: series
                };
            },
            partyGenderDemographics() {
                const genderCounts = {};

                for (const item of this.filteredPartyMembers.map(value => value.Gender).flat()) {
                    genderCounts[item] = genderCounts[item] ? genderCounts[item] + 1 : 1;
                }

                const series = [ {
                    name: "Men",
                    data: [genderCounts["Man"] != null ? genderCounts["Man"] : 0],
                    pointWidth:60,
                    visible: true,
                    color: '#8085e9',
                    showInLegend: false
                }, {
                    name: "Women",
                    data: [genderCounts["Woman"] != null ? genderCounts["Woman"] : 0],
                    pointWidth:50,
                    visible: true,
                    color: '#f7a35c',
                    showInLegend: false
                }];
                const categories = ['Gender'];

                return {
                    chart: {
                        type: 'bar',
                        height:40,
                       marginLeft: 70,
                        backgroundColor: 'rgba(0,0,0,0)'
                    },
                    exporting: {
                        enabled: false,
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        categories: categories,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    yAxis:{
                        visible: false,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    tooltip: {
                        pointFormat: '<span>{series.name}</span>: <b>{point.y} party members</b> ({point.percentage:.0f}%)<br/>',
                        outside:true
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'percent'
                        }
                    },
                    legend: {
                        visible: false
                    },
                    series: series
                };
            },
            xrange() {
                var min = new Date(1901,5,9).valueOf()
                var max = new Date().valueOf();
                let data = [];

                this.PartyDetails.PartyDateRecords.forEach(p => {
                        data.push({
                        x: new Date(p.CorrectedStartDate).valueOf(),
                        x2: p.CorrectedEndDate == null ? new Date().valueOf() : new Date(p.CorrectedEndDate).valueOf(),
                        dateString: p.StartDateString + " - " + (p.EndDateString == '' ? "present" : p.EndDateString),
                        y: 0,
                        color: this.PartyDetails.Colour
                    });
                });
            
                return {
                    chart: {
                        type: 'xrange',
                        height: 70,
                        backgroundColor: 'transparent'
                    },
                    exporting: {
                        enabled: false,
                    },
                    tooltip: {
                        headerFormat: '',
                        pointFormat: '<span>{series.name}</span>: <b>{point.dateString}</b><br/>',
                        outside:true
                    },
                    title: {
                        text: '',
                        margin: 0,
                    },
                    xAxis: {
                        type: 'datetime',
                        min: min,
                        max: max,
                        lineColor: '#5a5a5a',
                        tickColor: '#5a5a5a',
                    },
                    yAxis:{
                        title: {
                            text: ''
                        },
                        labels: {
                            enabled: false
                        },
                        categories: [this.PartyDetails.PrimaryName],
                        reversed: true,
                    },
                    plotOptions: {
                        series: {
                            minPointLength: 8
                        }
                    },
                    legend: {
                        visible: false
                    },
                    series: [{
                        name: this.PartyDetails.PrimaryName,
                        pointWidth: 10,
                        showInLegend: false,
                        data,
                    }]      
                };
            },
        }


    }
</script>
<style scoped>
    td.handbook-tablecol_linebreaks {
        white-space: pre;
    }
</style>
